import { render, staticRenderFns } from "./ManageHotelLayout.vue?vue&type=template&id=22bb45ae"
import script from "./ManageHotelLayout.vue?vue&type=script&lang=js"
export * from "./ManageHotelLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports